/* import __COLOCATED_TEMPLATE__ from './all-help-centers.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import type AppService from 'embercom/services/app-service';
import { action } from '@ember/object';
import { type Router } from '@ember/routing';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency-decorators';
import { type TaskGenerator } from 'ember-concurrency';
import { taskFor } from 'ember-concurrency-ts';
import type HelpCenterSite from 'embercom/models/help-center-site';
import ajax from 'embercom/lib/ajax';

interface Args {
  model: $TSFixMe;
}

interface Signature {
  Args: Args;
  Element: Element;
}

export default class AllHelpCenters extends Component<Signature> {
  @service declare router: Router;
  @service declare helpCenterService: $TSFixMe;
  @service declare appService: AppService;
  @service declare notificationsService: $TSFixMe;
  @service declare intl: $TSFixMe;

  @tracked showCreateHelpCenterModal = false;

  get maxHelpCenters() {
    return this.helpCenterService.maxNumberOfSites;
  }

  get hasMaxHelpCenters() {
    return this.args.model.helpCenters.length >= this.maxHelpCenters;
  }

  get hasHelpCenters() {
    return this.args.model.helpCenters.length > 0;
  }

  get canExportArticleUsageStats() {
    return this.appService.app.canUseFeature('collect-article-insertion-data');
  }

  @action
  toggleNewHelpCenterModal() {
    this.showCreateHelpCenterModal = !this.showCreateHelpCenterModal;
  }

  @action
  transitionToSettingsPage(helpCenter: HelpCenterSite) {
    this.router.transitionTo(
      'apps.app.settings.helpcenter.workspace-helpcenter',
      this.appService.app.id,
      helpCenter.id,
    );
  }

  @action
  async exportArticleUsageStats() {
    taskFor(this.exportArticleUsageDataByEmail).perform();
  }

  @task({ drop: true })
  *exportArticleUsageDataByEmail(): TaskGenerator<void> {
    try {
      yield ajax({
        url: '/ember/articles/export_usage',
        type: 'GET',
        data: {
          app_id: this.appService.app.id,
          admin_id: this.appService.app.currentAdmin.id,
        },
      });
      this.notificationsService.notifyConfirmation(
        this.intl.t('new-settings.helpcenter.export-success'),
      );
    } catch (_e) {
      this.notificationsService.notifyError(this.intl.t('new-settings.helpcenter.export-error'));
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Helpcenter::AllHelpCenters': typeof AllHelpCenters;
    'new-settings/helpcenter/all-help-centers': typeof AllHelpCenters;
  }
}
